export const SON_JUEUN_PROFILE_ID = "c1f4d8a6b37e49f0a8e6d2c5b9f71304";
export const LEE_JIYOUNG_PROFILE_ID = "bc6b506cb02fd601121155790aca481d";
export const SON_JUEUN_LEARNER_LABEL = "손사탐";

const HOST_PROFILES: Readonly<Record<string, string>> = {
  "la-son.garamlabs.com": SON_JUEUN_PROFILE_ID,
  "la-lee.garamlabs.com": LEE_JIYOUNG_PROFILE_ID,
};

export function profileIdForHost(hostname: string) {
  return HOST_PROFILES[hostname];
}

export function isAvatarHost(hostname: string) {
  return hostname in HOST_PROFILES;
}

export function learnerLabel(profileId: string, profileName: string) {
  return profileId === SON_JUEUN_PROFILE_ID ? SON_JUEUN_LEARNER_LABEL : profileName;
}
